import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faDownload } from '@fortawesome/free-solid-svg-icons';

const DocumentList = ({ documents, downloadedFiles, handleDownload }) => {
    return (
        <div id="document-list">
            {documents?.length > 0 ? (
                documents
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .map((doc) => (
                        <div
                            key={doc.uid} // ใช้ uid ของ document แทน id
                            style={{
                                backgroundColor: '#f2f2f2',
                                border: '1px solid #dddddd',
                                padding:'24px',
                                width:'100%',
                                textAlign:'left',
                                borderRadius: '16px',
                                boxSizing:'border-box',
                                marginBottom:'16px'
                            }}
                        >
                            <p style={{ fontSize: '1vw', fontWeight: 'bold', marginTop: 0, marginBottom: '16px' }}>
                                {doc.chapter} {/* แสดง chapter ของเอกสาร */}
                            </p>
                            <div style={{ 
                                width: '100%',
                                textAlign: 'left',
                                backgroundColor: '#f2f2f2',
                                border: '1px solid #dddddd',
                                borderRadius: '16px',
                                padding:'24px',
                                boxSizing:'border-box'
                                }}>
                               {doc.files?.map((file, fileIndex) => (
                                    <div
                                        key={`file-${fileIndex}`}
                                        style={{ display: 'flex', alignItems: 'center', gap: '16px', paddingBottom: '16px' }}
                                    >
                                        <FontAwesomeIcon
                                            icon={downloadedFiles[file.url] ? faCheck : faDownload}
                                            style={{
                                                color: downloadedFiles[file.url] ? 'green' : 'white',
                                                background: downloadedFiles[file.url] ? '#2187304D' : '#44526E',
                                                border: `2px solid ${downloadedFiles[file.url] ? '#218730' : '#44526E'}`,
                                                borderRadius: '1000px',
                                                fontSize: '21.26px',
                                                padding: '10px',
                                            }}
                                        />
                                        <a
                                            href={file.url}
                                            style={{
                                                textDecoration: 'none',
                                                color: '#000000',
                                                fontSize: '1vw',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            }}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => handleDownload(file.url)}
                                        >
                                            {file.filename} {/* แสดงชื่อไฟล์ */}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
            ) : (
                null
            )}
        </div>
    );
};

export default DocumentList;
